

export const hostname = `${process.env.REACT_APP_API_ENDPOINT}/api`;
